import React from 'react';
import moment from 'moment';

import { BookingCalendar } from 'webshop/js/shopping-cart-manager';
import { services, shops } from '../constants';
import TireChangeStore from '../tire-change-store';
import { Actions } from '../actions';

const Shop = ({ shop, onSelect, selected }) => {
    const { name, city } = shop,
        iconUrl = `/static/nettivanne/webshop/img/tire-change/location.svg`;
    return (
        <div className={`shop-box ${selected ? 'selected' : ''}`} onClick={() => onSelect()}>
            <img src={iconUrl} />
            <div>
                <span className="name">{name}</span>
                <span className="city">{city}</span>
            </div>
        </div>
    )
};

const ShopSelect = ({ value, shops }) => (
    <div className="shop-select">
        <label>Valitse toimipiste:</label>
        <div className="options">
            {shops.map(s => (
                <Shop
                    key={s.id}
                    shop={s}
                    selected={value == s.id}
                    onSelect={() => Actions.setSelectedShop(s.id)}
                />
            ))
            }
        </div>
    </div>
);

class Booking extends React.Component {
    constructor(props) {
        super(props);
        const storeData = TireChangeStore.getAll();
        this.state = {
            selectedService: storeData.selectedService,
            selectedShop: storeData.selectedShop,
            selectedSlot: storeData.selectedSlot,
            shops: storeData.shops,
        }
        this.update = this.update.bind(this);
    }
    shouldComponentUpdate(_, nextState) {
        if (nextState.selectedShop != this.state.selectedShop
            || nextState.selectedService != this.state.selectedService
            || nextState.shops != this.state.shops) {
            return true;
        }
        return false;
    }
    update() {
        const storeData = TireChangeStore.getAll();
        this.setState({
            selectedService: storeData.selectedService,
            selectedShop: storeData.selectedShop,
            selectedSlot: storeData.selectedSlot,
            shops: storeData.shops,
        });
    }
    componentDidMount() {
        TireChangeStore.addChangeListener(this.update);
    }
    componentWillUnmount() {
        TireChangeStore.removeChangeListener(this.update);
    }
    renderCalendarPlaceholder() {
        return (
            <div className="calendar-placeholder">
                <div className="placeholder-box">
                    <span>Lisää rekisterinumero ja valitse autotyyppi niin pääset selaamaan vapaita aikoja.</span>
                </div>
            </div>
        );
    }
    prebookAndContinue() {
        const { selectedSlot, selectedService } = this.state,
              payload = {
                door: selectedSlot[0],
                time: selectedSlot[1],
                duration: services.find(s => s.id == selectedService).duration,
              };
        $.post('/_ajax/webshop/pre_book', payload, (r) => {
            window.scrollTo(0, 0);
            this.props.changePhase();
        });
    }
    render() {
        const { selectedService, selectedShop, shops } = this.state,
            shop = shops.find(s => s.id == selectedShop);
        return (
            <section className="booking">
                <h2>2. Toimipiste ja vaihtoaika</h2>
                {selectedService && <ShopSelect value={selectedShop} shops={shops} />}
                {
                    (selectedShop && selectedService) ? (
                        <BookingCalendar
                            hideShop
                            hideSkip
                            stickySummary
                            noPreBook
                            onSelect={slot => Actions.setSelectedSlot(slot)}
                            onConfirm={() => this.prebookAndContinue()}
                            confirmButtonText="Vahvista aika"
                            summaryExtraText="HUOM: Vahvistuksen jälkeen pidämme aikaa varattuna 10 minuuttia, kunnes varaus on maksettu."
                            shop={shop}
                            rows={[]}
                            serviceId={selectedService}
                        />
                    ) : this.renderCalendarPlaceholder()
                }
            </section>
        );
    }
}

export default Booking;


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/components/Booking.js
 **/